export default {
  task: '任务',
  number: '数据编号',
  submitter: '提交人',
  reviewer: '审核人',
  apprStatus: '审核状态',
  passAll: '全部通过',
  refuseAll: '全部拒绝',
  reviewAll: '全部待审核',
  reviewPending: '待审核',
  passOne: '第一次通过',
  passTwo: '第二次通过',
  refuseOne: '第一次拒绝',
  refuseTwo: '第二次拒绝',
  reviewOne: '第一次待审核',
  reviewTwo: '第二次待审核',
  reviewFour: '第四次待审核',
  exportStatus: '导出状态',
  notExported: '未导出',
  exported: '已导出',
  to: '至',
  start: '开始日期',
  end: '结束日期',
  formStr1: '质检员',
  formStr2: '结算状态',
  formStr3: '全部',
  formStr4: '未结算',
  formStr5: '已结算',
  formStr6: '清空筛选',
  inquire: '查询',
  created: '创建时间',
  updated: '修改时间',
  date: '完成时间',
  gain: '获得泛函币',
  operating: '操作',
  review: '审核',
  reviewQuick: '快速审核',
  view: '查看',
  revise: '修改',
  reviewOpinion: '审核意见',
  determine: '确定',
  nodata: '没有数据',
  week: '最近一周',
  oneMonth: '最近一个月',
  threeMonth: '最近三个月',
  the: '第',
  passFrequency: '次通过',
  reviewFrequency: '次待审核',
  refuseFrequency: '次拒绝',
  exporting: '正在导出',
  recycling: '正在被回收',
  recycled: '已被回收',
  deal: '正在批处理',
  unknown: '未知',
  appealing: '申诉中',
  transferred: '正在被转移',
  taskStatus1: '全部',
  taskStatus2: '已提交可修改',
  taskStatus3: '审核中',
  taskStatus4: '初审通过',
  taskStatus5: '拒绝待修改',
  taskStatus6: '正在申诉',
  taskStatus7: '已回收',
  taskStatus8: '已验收',
  taskStatus9: '拒绝',
  taskStatus10: '观察期',
  taskStatus11: '正在被申诉',
  taskStatus12: '初审通过',
  taskStatus0: '任务状态',
  checkTimes: '质检次数',
  projectID: '项目ID',
  reviewsQuick01: '退出质检',
  reviewsQuick02: '正在退出质检页面, 是否继续?',
  reviewsQuick03: '提示',
  reviewsQuick04: '取消',
  // L新增的
  taskID: '任务ID',
  teamID: '泛团ID',
  assessor: '审核员',
  time: '时间',
  auditNumber: '审核次数',
  reSet: '重置',
  passTheAudit: '审核通过',
  submittedForModification: '',
  hasRecycled: '已回收',
  startTime: '开始时间',
  endTime: '结束时间',
  reviewProgress: '审核进度',
  submissionTime: '提交时间',
  auditTime: '审核时间',
  oneReview: '一层待审',
  twoReview: '二层待审',
  threeReview: '三层待审',
  acceptor: '验收人',
  pendingAcceptance: '待验收'
}



// WEBPACK FOOTER //
// ./src/lang/zh/taskreviews.js